// src/components/MapComponent.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const center = { lat: 45.435, lng: 28.007 };

const markers = [
  { id: 1, position: { lat: 45.435, lng: 28.007 } },
  { id: 2, position: { lat: 45.436, lng: 28.005 } },
  { id: 3, position: { lat: 45.434, lng: 28.009 } },
];

function MapComponent() {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAyHW3ZLQ8WsuqKI0hvKrWn50nYCjjzGwM", // Replace with your API key
  });

  if (loadError) return <Typography>Error loading map</Typography>;
  if (!isLoaded) return <Typography>Loading map...</Typography>;

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14}>
      {markers.map((marker) => (
        <Marker
          key={marker.id}
          position={marker.position}
          icon={{
            url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png", // Use a car icon URL if available
            scaledSize: new window.google.maps.Size(32, 32),
          }}
        />
      ))}
    </GoogleMap>
  );
}

export default React.memo(MapComponent);
